/**
 * Cintra Product > Feature > Section
 */
export type CintraProduct = 'Bureau' | 'Payroll' | 'EmployeeHub' | 'AdminHub' | 'Unset' | 'HR';

export const getProductHelpUrl = () => 'https://cintra.freshdesk.com/support/home';
